/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Corporate_Finance_Workflow_EditorInputs */

const en_corporate_finance_workflow_editor = /** @type {(inputs: Corporate_Finance_Workflow_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow editor`)
};

const nl_corporate_finance_workflow_editor = /** @type {(inputs: Corporate_Finance_Workflow_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow-editor`)
};

/**
* | output |
* | --- |
* | "Workflow editor" |
*
* @param {Corporate_Finance_Workflow_EditorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const corporate_finance_workflow_editor = /** @type {((inputs?: Corporate_Finance_Workflow_EditorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Corporate_Finance_Workflow_EditorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_corporate_finance_workflow_editor(inputs)
	return en_corporate_finance_workflow_editor(inputs)
});